import React from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { DtLoader } from "../loader";

export interface EmptyStateProps {
    icon: React.ReactNode;
    header: string;
    subheader?: string;
    action?: () => void;
    actionLabel?: string;
    actionIcon?: React.ReactNode;
    isLoadingState?: React.ReactNode;
    loadingMessage?: string;
    minHeight?: number | string; 
}

const EmptyState: React.FC<EmptyStateProps> = ({
    icon,
    header,
    subheader,
    action,
    actionLabel = "Action",
    actionIcon,       // Default icon
    isLoadingState,
    loadingMessage,
    minHeight = 300, 
}) => (
    <Box
        sx={{
            minHeight, 
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            gap: 0
        }}
    >
        <Stack spacing={1} alignItems="center">
            {isLoadingState ? (
                <DtLoader message={loadingMessage} />
            ) : (
                <>
                    <Box>{icon}</Box>
                    <Typography variant="h6" fontWeight={600} align="center" sx={{ color: 'text.secondary' }}>
                        {header}
                    </Typography>
                    {subheader && (
                        <Typography variant="body2" color="text.secondary" align="center">
                            {subheader}
                        </Typography>
                    )}
                    {action && (
                        <Button
                            size="small"
                            variant="outlined"
                            startIcon={actionIcon}
                            onClick={action}
                        >
                            {actionLabel}
                        </Button>
                    )}
                </>
            )}
        </Stack>
    </Box>
);

export { EmptyState };